import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

// Initialize analytics in development mode only in non-production environments
if (import.meta.env.PROD) {
  import('./utils/analytics').then(({ initGA }) => initGA());
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
